import { BackCardCollectionType } from '../../Prototype/UI/BackCardCollectionType';
import {
    TActionType,
    TransactionType,
} from '../../Utility/Tracking/DataSet/Transaction';
import { trackTransaction } from '../../Utility/Tracking/TrackingHelpers/Transaction';
import { IGameState } from '../Game/IGameState';
import { IPlayerState } from './IPlayerState';
import { setBoosterTNT, setCoins } from './PlayerInventoryHelper';
import { setStateTaskData } from './PlayerStateHelper';
import { PlayerTask } from './PlayerTasks';

export function unlockBackCard(
    state: IGameState,
    backcardId: number,
    showTask: boolean = true
): IGameState {
    state = { ...state };

    const backcards = state.playerState.backcards.slice();
    const max = Object.keys(BackCardCollectionType).length * 3;

    // Get last unlocked card (reversed) index.
    const lastIx = backcards
        .slice()
        .reverse()
        .findIndex(x => x > 0);
    if (lastIx > 0) {
        backcards.splice(-lastIx);
    }

    // First check if the backcard is already unlocked.
    if (
        backcards[backcardId - 1] === undefined ||
        backcards[backcardId - 1] < 1
    ) {
        // Check if we've unlocked ALL backcards.
        if (backcards.length < max) {
            // If ID is not the next in the sequence, add zeros until get there.
            for (let i = backcards.length, n = backcardId; i < n; i++) {
                if (backcards[i] === undefined) {
                    backcards.push(0);
                }
            }

            // Unlock the backcard as "unseen".
            backcards[backcardId - 1] = 2;

            if (showTask) {
                backcards[backcardId - 1] = 1;
                state.playerState = setStateTaskData(state.playerState, {
                    task: PlayerTask.UNLOCK_BACKCARD,
                    backcardId: backcardId,
                });
            }

            state.playerState.backcards = backcards;
        }

        // Rewards: +500 coins and +1 TNT.
        // Rewards are still given if ALL backcards are unlocked but not if this function is called for a backcard
        // that is already unlocked.
        state.playerState = setCoins(
            state.playerState,
            state.playerState.coins + 500,
            showTask
        );
        state.playerState = setBoosterTNT(
            state.playerState,
            state.playerState.inventory.boosterTNT + 1,
            showTask
        );
        trackTransaction(
            state,
            TransactionType.REWARD,
            TActionType.WEEKLY_EVENT
        );
    }

    return state;
}

export function unlockNextBackCard(state: IGameState): IGameState {
    // Get the next card available. After the first 6 (3x default + 3x stars).
    // 0, 1, 2 -> default
    // 3, 4, 5 -> stars
    const index = state.playerState.backcards.findIndex(
        (x, i) => x < 1 && i > 5
    );
    if (index === -1) {
        return unlockBackCard(
            state,
            state.playerState.backcards.length < 6
                ? 7
                : state.playerState.backcards.length + 1
        );
    } else {
        return unlockBackCard(state, index + 1);
    }
}

export function seeNewBackcards(state: IPlayerState): IPlayerState {
    return {
        ...state,
        backcards: state.backcards.map(x => (x === 1 ? 2 : x)),
    };
}
